/*eslint-disable */
import React from "react";
import check_icon from "../../../assets/10_POSVENTA/05_mantenimiento/icon-check.svg";
//import "./MaintenanceTable.css";

const MaintenanceTable = () => {
  return (
    <>
      {/* <div className="title-posventa-asistecia-component">Mantenimiento</div> */}
      <div className="table-container">
        <table className="maintenance-table">
          <thead>
            <tr>
              <th>Revisión</th>
              <th>Gasolina</th>
              <th>Híbridos</th>
              <th>Eléctricos</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Cambio de aceite motor, filtro de aceite y cambio de filtro aire motor.
              </td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Mantenimiento de motor Gasolina - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Mantenimiento de motor Híbrido - Hyundai Colombia" /></td>
              <td></td>
            </tr>
            <tr className="alt-row">
              <td>
                Revisión de sistema frenos, líquido frenos, sistema de embrague y líquido refrigerante cambiar de ser requerido.
              </td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión de frenos y líquidos Gasolina - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión de frenos y líquidos Híbrido - Hyundai Colombia" /></td>
              <td></td>
            </tr>
            <tr>
              <td>
                Inspección de sistema de combustible y filtro de combustible cambiar de ser requerido.
              </td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Inspección de combustible Gasolina - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Inspección de combustible Híbrido - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Inspección de combustible Eléctrico - Hyundai Colombia" /></td>
            </tr>
            <tr className="alt-row">
              <td>Inspección de correa HSG, cambiar de ser requerido.</td>
              <td></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Inspección de correa HSG Híbrido - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Inspección de correa HSG Eléctrico - Hyundai Colombia" /></td>
            </tr>
            <tr>
              <td>Diagnóstico con el GDS (análisis de escáner).</td>
              <td></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Diagnóstico con escáner GDS Híbrido - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Diagnóstico con escáner GDS Eléctrico - Hyundai Colombia" /></td>
            </tr>
            <tr className="alt-row">
              <td>
                Revisión sistema de carga y estado de batería (equipo diagnóstico).
              </td>
              <td></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión de batería y carga Híbrido - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión de batería y carga Eléctrico - Hyundai Colombia" /></td>
            </tr>
            <tr>
              <td>Revisión caja de dirección y guardapolvos (fugas).</td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión de dirección y fugas Gasolina - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión de dirección y fugas Híbrido - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión de dirección y fugas Eléctrico - Hyundai Colombia" /></td>
            </tr>
            <tr className="alt-row">
              <td>
                Revisión suspensión delantera y trasera, semiejes y guardapolvos.
              </td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión de suspensión Gasolina - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión de suspensión Híbrido - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión de suspensión Eléctrico - Hyundai Colombia" /></td>
            </tr>
            <tr>
              <td>Alineación y balanceo, según estado inspección.</td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Alineación y balanceo Gasolina - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Alineación y balanceo Híbrido - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Alineación y balanceo Eléctrico - Hyundai Colombia" /></td>
            </tr>
            <tr className="alt-row">
              <td>
                Revisión e inspección tren de potencia (AT/MT) / Para las transmisiones automáticas se revisa y verifica el estado del fluido y solo en caso de ser necesario cambiarlo.
              </td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión del tren de potencia Gasolina - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión del tren de potencia Híbrido - Hyundai Colombia" /></td>
              <td style={{textAlign: "center"}}><img src={check_icon} alt="Revisión del tren de potencia Eléctrico - Hyundai Colombia" /></td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default MaintenanceTable;
